import { combineReducers } from 'redux';

import { AppReducer } from './AppReducer';
import { Login } from './Login';

export default combineReducers({
  Login,
  AppReducer,
});
